import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import AdminLogin from "@/admin/AdminLogin";
import AdminSubmissions from "@/admin/AdminSubmissions";
import { I18nProvider } from "@/i18n/I18nProvider";
import { AuthProvider } from "@/admin/AuthProvider";
import SmoothScroll from "@/components/motion/SmoothScroll";

function App() {
  useEffect(() => {
    document.title = "Smart Terminals — Driving Oman's Digital Future";
  }, []);

  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:slug" element={<ProductDetailPage />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/submissions" element={<AdminSubmissions />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
